import { c as _c } from "react/compiler-runtime";
import type { Locale } from '@/i18n/locales';
import type { StoreWithDistance } from '../lib/types';
type StoreLocationLabelProps = {
  store: StoreWithDistance;
  locale: Locale;
};
export function StoreLocationBadge(t0) {
  const $ = _c(5);
  const {
    store,
    locale
  } = t0;
  let t1;
  if ($[0] !== locale || $[1] !== store) {
    t1 = getStoreLocationText(store, locale);
    $[0] = locale;
    $[1] = store;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const text = t1;
  let t2;
  if ($[3] !== text) {
    t2 = text ? <p className="ut-body-fixed-sm text-secondary">{text}</p> : null;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function getStoreLocationText(store: StoreWithDistance, locale: Locale) {
  const regionOrCity = store.address?.region || store.address?.city || '';
  if (showRegionOrCity(store.distance, regionOrCity)) {
    return regionOrCity;
  }
  if (store.distance != null) {
    return formatDistance(store.distance, locale);
  }
  return '';
}
function showRegionOrCity(distance: StoreWithDistance['distance'], regionOrCity: string) {
  return regionOrCity && (distance == null || distance >= 100);
}
function formatDistance(distance: number, locale: Locale) {
  if (distance < 1) {
    return Math.round(distance * 1000).toLocaleString(locale, {
      style: 'unit',
      unit: 'meter',
      unitDisplay: 'short',
      maximumFractionDigits: 0
    });
  }
  return distance.toLocaleString(locale, {
    style: 'unit',
    unit: 'kilometer',
    unitDisplay: 'short',
    maximumFractionDigits: 1
  });
}